import axios from "axios";
import { User, UserPreference } from "../types/SettingsTypes";

const SERVICES_URL = window.MLBBest.envVariables.SERVICES_URL;
const API_URL = `${SERVICES_URL}`;

export const getAllActiveUserApi = (): Promise<User[]> =>
  axios.get(`${API_URL}/users/active`).then(response => response.data);

export const saveUserApi = (user: any): Promise<any> =>
  axios.post(`${API_URL}/users/${user.id}`, user).then(response => response.data);

export const saveUserBulkApi = (userList: any): Promise<any> =>
  axios.post(`${API_URL}/users/`, userList).then(response => response.data);

export const saveUserPreference = (userPreference: UserPreference): Promise<UserPreference> =>
  axios.post(`${API_URL}/userPreference`, userPreference).then(response => response.data);
